module.exports = __webpack_public_path__ + "img/trip_13.f04f7300.jpg";